import React from 'react';
import {LandingPagePropTypes, NeuroMessage, useNeuroState} from '@ignitesales/neuro-application';
import ReactSVG from 'react-svg';


const LandingPage = ({ componentClass, onStartGuideClick, isLoadingNextPage }) => {
    const { bankSelected } = useNeuroState();
    
    return (
        <div className={`${componentClass} ${bankSelected}__landingPage`}>
            { bankSelected === 'jefferson' ? null : <ReactSVG src={'/classpath/assets/images/icons/giant-dogwood.svg'} className={`${componentClass}__background`}/>}
            <div className={`central-container ${bankSelected}`}>
                <div className='logo-container'>
                    <ReactSVG src={bankSelected === "centralbank" ? '/classpath/assets/images/central-logo-landing.svg' : bankSelected === "jefferson" ? '/classpath/assets/images/jefferson-logo-white.svg' : '/classpath/assets/images/bank-central-vertical.svg'}/>
                </div>
                <div className="data">
                    <div className="left-side">
                        <div className="info-container">
                            <NeuroMessage className='landingTitle' id="landing.title1" tagName="span" />
                            <NeuroMessage className='landingSubTitle1' id="landing.subtitle1" tagName="span" />
                            <NeuroMessage className='landingSubTitle2' id="landing.subtitle2" tagName="span" />
                            <button onClick={() => onStartGuideClick('none')} disabled={isLoadingNextPage} className="btn btn-primary">
                                <NeuroMessage className='btnStarted' id="landing.start" tagName="span" />
                            </button>
                        </div>
                    </div>
                </div>
                <NeuroMessage className="copyright" id="copyright" tagName="span" />
            </div>
        </div>
    );
};

LandingPage.propTypes = LandingPagePropTypes;

export default LandingPage;
